module.exports = __webpack_public_path__ + "static/media/eyeLotion1.c68aaa1d.jpg";